import { CImage, CSidebar, CSidebarBrand, CSidebarHeader } from '@coreui/react';
import { useSelector, useDispatch } from 'react-redux';
import { SidebarNav } from '@webkit/components/SidebarNav.js';
import LogoImage from "@assets/images/logo-hostyble-light.png";
import navigation from '@routes/nav-routes.js';
import { Link } from 'react-router-dom';

const Sidebar = () => {

  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CSidebar
      className="border-end"
      colorScheme="dark"
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarHeader className="border-bottom">
        <CSidebarBrand component={Link} to="/">
          <CImage className="w-75 h-auto" src={LogoImage} />
        </CSidebarBrand>
        {/* <CCloseButton
          className="d-lg-none"
          light
          onClick={() => dispatch({ type: 'set', sidebarShow: false })}
        /> */}
      </CSidebarHeader>
      <SidebarNav items={navigation} />

    </CSidebar>
  );
}

export default Sidebar;